import { createSlice } from '@reduxjs/toolkit'
import { RootState } from 'store'
import { forgotPassword, getConfiguration, resetPassword, validateResetToken } from './thunks'

const user: AuthUser = {
  id: null,
  fullName: null,
  firstName: null,
  lastName: null,
  email: null,
  token: null,
  isAdmin: false,
  isGoldUser: false,
  mfaEnabled: false,
  mfaSecret: null,
  mfaQrCode: null,
  mfaHash: null,
}

const initialState: AuthenticationState = {
  user: user,
  error: null,
  loggedIn: false,
  checkingLoginStatus: false,
  status: 'idle',
  siteConfig: null,
}

const slice = createSlice({
  name: 'authentication',
  initialState,
  reducers: {
    resetAuthState: () => initialState,
  },
  extraReducers: (builder) => {
    // FORGOT PASSWORD
    builder
      .addCase(forgotPassword.pending, (state) => {
        state.status = 'loading'
        state.error = null
      })
      .addCase(forgotPassword.rejected, (state, action) => {
        state.status = 'failed'
        state.error = action?.payload?.message || 'Something went wrong. Please try again.'
      })
      .addCase(forgotPassword.fulfilled, (state) => {
        state.status = 'succeeded'
      })

    // VALIDATE RESET TOKEN
    builder
      .addCase(validateResetToken.pending, (state) => {
        state.status = 'loading'
        state.error = null
      })
      .addCase(validateResetToken.rejected, (state, action) => {
        state.status = 'failed'
        state.error = action?.payload?.message || 'Something went wrong. Please try again.'
      })
      .addCase(validateResetToken.fulfilled, (state) => {
        state.status = 'succeeded'
      })

    // RESET PASSWORD
    builder
      .addCase(resetPassword.pending, (state) => {
        state.status = 'loading'
        state.error = null
      })
      .addCase(resetPassword.rejected, (state, action) => {
        state.status = 'failed'
        state.error = action?.payload?.message || 'Something went wrong. Please try again.'
      })
      .addCase(resetPassword.fulfilled, (state) => {
        state.status = 'succeeded'
      })

    // SiteConfig
    builder
      .addCase(getConfiguration.pending, (state) => {
        state.status = 'loading'
        state.error = null
      })
      .addCase(getConfiguration.rejected, (state, action) => {
        state.status = 'failed'
        state.error = action?.payload?.message || 'Something went wrong. Please try again.'
      })
      .addCase(getConfiguration.fulfilled, (state, action) => {
        state.status = 'succeeded'
        state.siteConfig = action.payload.siteConfig ?? null
      })
  },
})

export const { resetAuthState } = slice.actions

export const selectAuth = (state: RootState): AuthenticationState => state.authentication

export default slice.reducer
